import React from "react";
import { Button, Dropdown } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useAuth } from "../../AuthProvider";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SupportIcon } from "../../assets/images/support-icon.svg";
import { clearAuthTokens } from "../../utils/operatorAuth";

const Header = () => {
  const navigate = useNavigate();
  const { setCompanyProfile, setShowProfile, companyProfileData } = useAuth();

  // Handle logout action
  const handleLogout = () => {
    clearAuthTokens();
    window.location.href = "/login";
  };

  const createOrder = () => {
    // Navigate to the OrderCreate page
    if (companyProfileData) {
      navigate("/orders/create");
    } else {
      setCompanyProfile(true);
    }
  };

  const createTransport = () => {
    if (companyProfileData) {
      navigate("/my-fleet?add=1");
    } else {
      setCompanyProfile(true);
    }
  };

  const menuItems = [
    {
      key: "1",
      label: "Создать заказ",
      onClick: createOrder,
    },
    {
      key: "2",
      label: "Создать транспорт",
      onClick: createTransport,
    },
  ];

  const supportMenuItems = [
    {
      key: "1",
      label: (
        <a href="mailto:info@itruck.io" className="support-menu-link">
          info@itruck.io
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a href="tel:+996709222111" className="support-menu-link">
          +996 709 222 111
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a
          href="https://wa.me/996709222111"
          target="_blank"
          rel="noopener noreferrer"
          className="support-menu-link support-menu-link--whatsapp"
        >
          WhatsApp
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9997 1.83337C5.93713 1.83337 1.83301 5.93749 1.83301 11C1.83301 12.6656 2.27734 14.2275 3.0537 15.5734L1.83301 20.1667L6.59509 19.041C7.90236 19.7585 9.40315 20.1667 10.9997 20.1667C16.0622 20.1667 20.1663 16.0626 20.1663 11C20.1663 5.93749 16.0622 1.83337 10.9997 1.83337ZM10.9997 18.5249C9.46757 18.5249 8.04266 18.067 6.8538 17.2805L4.04039 17.997L4.82949 15.3079C3.97572 14.0874 3.47486 12.6022 3.47486 10.9998C3.47486 6.84398 6.84386 3.47497 10.9997 3.47497C15.1555 3.47497 18.5245 6.84398 18.5245 10.9998C18.5245 15.1556 15.1555 18.5246 10.9997 18.5246V18.5249Z" fill="#25D366" />
            <path d="M13.1775 12.223L15.423 13.2816C15.5261 13.3301 15.5921 13.4347 15.5828 13.5482C15.5586 13.8436 15.44 14.4358 14.9091 14.9667C13.4108 16.4651 10.7201 14.7697 10.6105 14.7042C9.94873 14.3487 9.31995 13.873 8.72364 13.277C8.1276 12.6809 7.65169 12.0518 7.29618 11.39C7.23044 11.2807 5.53512 8.58985 7.03373 7.09117C7.56455 6.56032 8.15673 6.44173 8.45218 6.41749C8.56587 6.40821 8.67028 6.47421 8.71875 6.57734L9.77755 8.82292C9.82756 8.92914 9.80565 9.05547 9.72264 9.13849L8.9335 9.92766C8.76283 10.0983 8.71282 10.3641 8.83038 10.575C9.11834 11.0914 9.50557 11.5888 9.95414 12.0464C10.4117 12.495 10.9091 12.8825 11.4254 13.1702C11.6363 13.2878 11.9019 13.2378 12.0728 13.0671L12.8619 12.2779C12.9449 12.1949 13.0713 12.1727 13.1775 12.223Z" fill="#25D366" />
          </svg>
        </a>
      ),
    },
  ];

  let avatar;

  // if (user?.avatar) {
  //   avatar = `#ccc url(${user?.avatar}) no-repeat center center / cover`;
  // }

  // if (user?.profile?.company_profile?.profile_images) {
  //   avatar = `#ccc url(${user?.profile?.company_profile?.profile_images || ""}) no-repeat center center / cover`;
  // }

  return (
    <div className="header">
      <div className="header__wrapper">
        <a href="/" className="header__logo" aria-label="Home">
          {/* Logo */}
        </a>
        <div className="header__create-order">
          <Dropdown menu={{ items: menuItems }} placement="bottomRight" overlayClassName="my-custom-dropdown-menu" >
            <Button type="primary" size="large">
              Создать
            </Button>
          </Dropdown>
        </div>
        <div className="header__support">
          <Dropdown menu={{ items: supportMenuItems }} placement="bottomRight" overlayClassName="support-dropdown-menu">
            <Button size="large" className="header__support-btn">
              <SupportIcon style={{ color: "#2F80ED" }} />
              Служба поддержки
            </Button>
          </Dropdown>
        </div>
        <div className="header__socials">
          <a
            className="header__socials__item header__socials__item--tiktok"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            {/* TikTok icon */}
          </a>
          <a
            className="header__socials__item header__socials__item--instagram"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            {/* Instagram icon */}
          </a>
        </div>
        <div className="header__locale">RU</div>
        <div className="header__user">
          <Dropdown
            menu={{
              items: [
                {
                  key: "my-profile",
                  label: "Мой Профиль",
                  icon: <UserOutlined />,
                  onClick: () => setShowProfile(true),
                },
                {
                  key: "company-profile",
                  label: "Профиль Компании",
                  icon: <UserOutlined />,
                  onClick: () => {
                    setCompanyProfile(true);
                  },
                },
                {
                  key: "logout",
                  label: "Выйти",
                  icon: <LogoutOutlined />,
                  onClick: handleLogout,
                },
              ],
            }}
            placement="bottomRight"
            arrow
          >
            <div
              className="header__user__avatar"
              style={avatar ? { background: avatar, cursor: "pointer" } : {}}
              aria-label="User menu"
            />
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default Header;
